import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const CustomOutlinedSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
      padding: 0,
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          border: '2px solid #1976d2',
          backgroundColor: 'transparent'
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#1976d2',
        },
      },
      '&.Mui-disabled': {
        color: '#bdbdbd',
        '& + .MuiSwitch-track': {
          border: '2px solid #bdbdbd',
          backgroundColor: 'transparent'
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#bdbdbd',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#bdbdbd',
      width: 20,
      height: 20,
      boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
      borderRadius: 20,
      backgroundColor: 'transparent',
      border: '2px solid #bdbdbd',
      boxSizing: 'border-box',
      opacity: 1,
    },
  }));

  export default CustomOutlinedSwitch;